import axios from 'axios';

import type { GetApiV1IssueFinderListingsResponse } from '~/api/generated';

export type IssueFinderListingMonth = GetApiV1IssueFinderListingsResponse[number];

export async function fetchIssueFinderListings(): Promise<GetApiV1IssueFinderListingsResponse> {
  const { data } = await axios.get<GetApiV1IssueFinderListingsResponse>('/api/v1/issue_finder_listings');

  return data;
}
